import React from "react";
import { withStyles, Button } from "@material-ui/core";
import Select from "../../../../../../common/StyledSelect";
import ShipmentList from "./ShipmentList";
import MoveBillsInProgress from "./MoveBillsInProgress";
import MoveBillsError from "./Error";
import styles from "../../styles";

const localStyles = (theme) => ({
  confirmButton: {
    fontSize: theme.textFontSize,
    textTransform: "uppercase",
    borderRadius: "2px",
    width: "100%",
    "&$disabledConfirmButton,&$disabledConfirmButton:hover": {
      color: theme.iconColor,
    },
  },
  actionButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    margin: "20 0 8",
  },
  selectedShipment: {
    maxHeight: 350,
    overflowX: "hidden",
  },
});

const ShipmentsModel = (props) => {
  const {
    classes,
    data,
    onShipmentSelected,
    fromTrailer,
    movedToTrailerNumber,
    handleSaveBills,
    toTrailersList,
    handleChange,
    errorInfo,
    isMoveBillsInProgress,
    moveBillsDelayed,
    moveBillError,
    onClose,
  } = props;

  return (
    <>
      <div className={classes.containerStyle}>
        <div className={classes.flexRow}>
          <Select
            autoFocus
            value={movedToTrailerNumber?.label}
            data={toTrailersList?.filter((trailer) => trailer.trailerId?.toLowerCase() !== fromTrailer.trailerId?.toLowerCase())}
            onChange={handleChange("movedToTrailerNumber")}
            textFieldProps={{
              id: "toTrailersList",
              label: "To Trailer",
              variant: "outlined",
              helperText: errorInfo?.movedToTrailerNumber,
            }}
            isDisabled={data.length === 0}
            isNotClearable
            error={Boolean(errorInfo?.movedToTrailerNumber)}
          />
        </div>
        <div className={`${classes.selectedShipment} customScroll`}>
          <ShipmentList data={data} onShipmentSelected={onShipmentSelected} />
        </div>
        {moveBillError && <MoveBillsError message={moveBillError} />}
        <div className={classes.actionButtons}>
          <Button
            color="primary"
            variant="contained"
            className={classes.confirmButton}
            onClick={handleSaveBills}
            disabled={data.length === 0}
            classes={{
              disabled: classes.disabledConfirmButton,
            }}
          >
            MOVE SELECTED BILLS
          </Button>
        </div>
      </div>
      {isMoveBillsInProgress && (
        <MoveBillsInProgress close={onClose} delayed={moveBillsDelayed} />
      )}
    </>
  );
};

export default withStyles((theme) => ({
  ...styles(theme),
  ...localStyles(theme),
}))(ShipmentsModel);
